import { render, staticRenderFns } from "./checkback-list-detail.vue?vue&type=template&id=b6f8442c&scoped=true"
import script from "./checkback-list-detail.vue?vue&type=script&lang=js"
export * from "./checkback-list-detail.vue?vue&type=script&lang=js"
import style0 from "./checkback-list-detail.vue?vue&type=style&index=0&id=b6f8442c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f8442c",
  null
  
)

export default component.exports